export const NAV_LINKS = [
  { label: "About", href: "/#about" },
  { label: "Programs", href: "/#programs" },
  { label: "Community", href: "/#community" },
  { label: "Careers", href: "/employment" },
  { label: "Officiate", href: "/coaches-officials" },
  { label: "Ownership", href: "/team-owners" },
  { label: "Partners", href: "/partnerships" },
  { label: "Budget", href: "/budget" },
  { label: "Store", href: "/store" },
  { label: "Voices", href: "/voices" },
  { label: "Family", href: "/family" },
];

export const PILLARS = [
  {
    num: "01",
    title: "Elite Competition",
    body: "International tournaments and showcases that pit Africa's brightest talent against America's finest. We forge greatness on hardwood.",
    image:
      "https://images.unsplash.com/photo-1519684093736-61f49e250672?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    num: "02",
    title: "Community Mentorship",
    body: "Year-round development. Pro players and coaches working directly with youth — building character before championships.",
    image:
      "https://images.unsplash.com/photo-1520399636535-24741e71b160?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    num: "03",
    title: "Cultural Exchange",
    body: "More than basketball. A bridge between continents through music, fashion, education — celebrating the diaspora's shared rhythm.",
    image:
      "https://images.unsplash.com/photo-1505666287802-931dc83948e9?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];

export const STATS = [
  { value: "14", label: "Countries" },
  { value: "320+", label: "Athletes" },
  { value: "48", label: "Programs" },
  { value: "9", label: "Cities" },
];

export const MARQUEE_WORDS = [
  "AFROAM",
  "/",
  "COMMUNITY",
  "/",
  "CULTURE",
  "/",
  "COMPETITION",
  "/",
  "BROTHERHOOD",
  "/",
];
